module.exports = __webpack_public_path__ + "img/A2_13.605e3c8b.png";